var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDashboard = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 18,
    height: 18,
    transform: "translate(2 2)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24966",
    "data-name": "Group 24966",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61103",
    "data-name": "Path 61103",
    d: "M18.3,3H5.7A2.652,2.652,0,0,0,3,5.7V18.3A2.652,2.652,0,0,0,5.7,21H18.3A2.652,2.652,0,0,0,21,18.3V5.7A2.652,2.652,0,0,0,18.3,3Zm1.8,15.3a1.805,1.805,0,0,1-1.8,1.8H5.7a1.805,1.805,0,0,1-1.8-1.8V7.5H20.1Zm0-11.7H3.9V5.7A1.805,1.805,0,0,1,5.7,3.9H18.3a1.805,1.805,0,0,1,1.8,1.8Z",
    transform: "translate(-3 -3)",
    fill: "#95A1B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61104",
    "data-name": "Path 61104",
    d: "M6.9,18.1h4.14a1.332,1.332,0,0,0,2.52,0H17.7a.85.85,0,0,0,.9-.9v-.9A6.3,6.3,0,0,0,6,16.3v.9A.85.85,0,0,0,6.9,18.1Zm5.4,0a.45.45,0,1,1,.45-.45A.425.425,0,0,1,12.3,18.1ZM6.9,16.3a5.171,5.171,0,0,1,1.26-3.42l.54.54.63-.63-.63-.54a5.312,5.312,0,0,1,3.15-1.35v.9h.9v-.9a5.24,5.24,0,0,1,3.15,1.35l-.54.54.63.63.54-.54A5.606,5.606,0,0,1,17.7,16.3v.9H13.56a1.432,1.432,0,0,0-.81-.81V13.6h-.9v2.79a1.432,1.432,0,0,0-.81.81H6.9Z",
    transform: "translate(-3.3 -3.7)",
    fill: "#95A1B2"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dashboard.1df8bc23.svg";
export { ForwardRef as ReactComponent };